import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    ivrList: [],
    ivrTermList: [],
    ivrWeekList: [],
    ivrPerformanceList: [],
    busy: false,
  },
  modules: {},
  mutations: {
    set(state, data) {
      state.ivrList = data
    },
    setTerm(state, data) {
      state.ivrTermList = data
    },
    setWeek(state, data) {
      state.ivrWeekList = data
    },
    setPerformance(state, data) {
      state.ivrPerformanceList = data
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {},
  actions: {
    async get(store, { readonly = false } = {}) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)
      const { status, message, data } = await POST('/api/web/ivr/list', { readonly })
      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },

    async getTerms(store, { readonly = false } = {}) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/ivr/reception/terms/list', { readonly })
      if (status === 200) {
        commit('setTerm', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },

    async getWeeks(store, { readonly = false } = {}) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/ivr/reception/weeks/list', { readonly })
      if (status === 200) {
        commit('setWeek', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },

    async getPerformance({ commit, state }, year) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/ivr/performance/list', { year })
      if (status === 200) {
        commit('setPerformance', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
